import { useEffect, useRef } from "react";

/** Flash the selected state, then move on — Hinge-style prompt advance. */
export function useAdvanceSoon(fn: () => void, ms = 180) {
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const fnRef = useRef(fn);
  fnRef.current = fn;

  useEffect(
    () => () => {
      if (timer.current) window.clearTimeout(timer.current);
    },
    []
  );

  return () => {
    if (timer.current) window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => fnRef.current(), ms);
  };
}
